/**
 * AI 可见性 API — GET /api/ai-visibility（跨品牌汇总）。
 * 批 4 追加：matrix / trend 分析支撑端点（契约见 kickoff 02 §7）。
 */
import client from "./client";
import type { AiVisibility, VisibilityMatrix, VisibilityTrend } from "../types";

/** 获取 AI 可见性数据（跨品牌汇总，可按公司筛选）。 */
export async function getAiVisibility(companyId?: string): Promise<AiVisibility[]> {
  return client.get<unknown, AiVisibility[]>("/ai-visibility", {
    params: companyId ? { company_id: companyId } : undefined,
  });
}

/**
 * 获取全景矩阵（话题 × 平台 热力矩阵，days 默认 7）。
 * 后端并行开发中；调用方需自行 try/catch 做优雅降级。
 */
export async function getVisibilityMatrix(
  brandId?: string,
  days = 7,
): Promise<VisibilityMatrix> {
  return client.get<unknown, VisibilityMatrix>("/ai-visibility/matrix", {
    params: { ...(brandId ? { brand_id: brandId } : {}), days },
  });
}

/**
 * 获取话题 7 日趋势（topic + platform 必填）。
 * 后端并行开发中；调用方需自行 try/catch 做优雅降级。
 */
export async function getVisibilityTrend(
  topic: string,
  platform: string,
  brandId?: string,
): Promise<VisibilityTrend> {
  return client.get<unknown, VisibilityTrend>("/ai-visibility/trend", {
    params: { ...(brandId ? { brand_id: brandId } : {}), topic, platform },
  });
}
